module.exports = __webpack_public_path__ + "img/65760.112a14d5.png";